import axios from "axios"

function getLiveReport({ hash }, {}, params) {
    return axios.get(`api/v1/live-reports/${hash}`, { params })
}

function getStudentLiveReports({ id }, {}, params) {
    return axios.get(`api/v1/students/${id}/live-reports`, { params })
}

function sendStudentComment({ id }, data) {
    return axios.post(
        `api/v1/live-reports/${id}/student-comment?_method=PUT`,
        data
    )
}

function deleteCommentRecord({ id }, data) {
    return axios.post(`api/v1/live-reports/${id}/delete-comment-record`)
}

function setStudentDiagnostic({ id }, data) {
    return axios.post(`/api/v1/live-reports/${id}/set-student-diagnostic`, data)
}

function getStudentLiveReportsWithDiagnostic({ id }) {
    return axios.get(`api/v1/students/${id}/live-reports-with-diagnostic`)
}

export const liveReportService = {
    getLiveReport,
    getStudentLiveReports,
    sendStudentComment,
    deleteCommentRecord,
    setStudentDiagnostic,
    getStudentLiveReportsWithDiagnostic,
}
